import { PageHeader } from "../../../../components/Headers/PageHeader";
import { SideFilters } from "./components/SideFilters";

import { useEffect, useState } from "react";
import { useContextSelector } from "use-context-selector";
import { ExploreItemsContext } from "../../../../contexts/ExploreItemsContext";
import { ExploreItemsHeader } from "./components/ExploreItemsHeader";
import { ExploreTable } from "./components/ExploreTable";
import { FilterDetails } from "./components/FilterDetails";
import * as S from "./styles";
import { useTheme } from "styled-components";
import { useMediaQuery } from "usehooks-ts";
import { DynamicReportMobile } from "./components/Mobile";
import { useTranslation } from "react-i18next";

export function DynamicReport() {
  const { t } = useTranslation();

  const [selectedPage, setSelectedPage] = useState<"filters" | "table">(
    "filters",
  );

  const { loadExploreItemsFilters } = useContextSelector(
    ExploreItemsContext,
    (context) => {
      return context;
    },
  );

  const { responsiveDesign } = useTheme();
  const isMobile = useMediaQuery(`(max-width: ${responsiveDesign.sm})`);

  const { fetchExploreItems, fetchExploreItemsCSV, exploreItemsLoading } =
    useContextSelector(ExploreItemsContext, (context) => {
      return context;
    });

  function handleSelectPage(page: "filters" | "table") {
    setSelectedPage(page);
  }

  useEffect(() => {
    loadExploreItemsFilters();
  }, []);

  return (
    <S.ExploreContainer>
      {!isMobile && <SideFilters />}

      <S.ExploreContentContainer>
        <PageHeader
          title={t("dynamicReport")}
          description={t("dynamicReportScreenDescription")}
          hasButtons={!isMobile && true}
          hasBorder={false}
          refreshFunction={() => {
            handleSelectPage("table");
            fetchExploreItems();
          }}
          downloadFunction={() => fetchExploreItemsCSV()}
          buttonType="search"
          loading={exploreItemsLoading}
          customBreadcrumbString={t("dynamicReport")}
        />

        {!isMobile && (
          <ExploreItemsHeader
            handleSelectPage={handleSelectPage}
            page={selectedPage}
          />
        )}

        {isMobile && <DynamicReportMobile />}

        {selectedPage === "filters"
          ? !isMobile && <FilterDetails />
          : !isMobile && <ExploreTable />}
      </S.ExploreContentContainer>
    </S.ExploreContainer>
  );
}
